import { render, staticRenderFns } from "./chartscount.vue?vue&type=template&id=ed3563bc"
import script from "./chartscount.vue?vue&type=script&lang=js"
export * from "./chartscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports